export default __webpack_public_path__ + "static/media/icon-api.344faaf8.svg";